module.exports = __webpack_public_path__ + "media/images/help/new-submission-page-2d6588127b8d8c31c1cac8d82156cbdc.png";